import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import axios from 'axios';
import configureStore from './redux/configureStore';
import { Provider } from 'react-redux';

axios.defaults.baseURL = 'https://eacstidatabase.org/api/';
// axios.defaults.baseURL = 'http://localhost:8095/api/';
axios.defaults.withCredentials = true;

const store = configureStore();

/** Ensure we only hard-redirect once */
let _redirectingToLogin = false;

/**
 * 1) Handle LOGIN "soft failures" even if server returns 204/200 with {type:'Fail'}
 *    We transform such responses into a rejected promise so Login.tsx catch{} can show a message.
 */
axios.interceptors.response.use(
    (res) => {
        const url = (res?.config?.url || '').toLowerCase();

        // Normalize relative URLs (might be 'login/' or '/api/login/')
        const isLoginCall =
            url.endsWith('/login') || url.endsWith('/login/') || url.includes('/login?');

        if (isLoginCall) {
            const isOK = res.status === 200 && res?.data && res.data.type === 'Success';
            if (!isOK) {
                const err: any = new Error(
                    res?.data?.message || 'Invalid email or password.'
                );
                err.response = res;
                err.userMessage = 'Invalid email or password.';
                return Promise.reject(err);
            }
        }

        return res;
    },
    async (error) => {
        const status = Number(error?.response?.status);
        const url = (error?.config?.url || '').toLowerCase();

        const isLoginCall =
            url.endsWith('/login') || url.endsWith('/login/') || url.includes('/login?');

        // 2) If login itself failed with 401/403/etc -> let Login.tsx handle and DON'T redirect here
        if (isLoginCall && [400, 401, 403, 409, 422, 429].includes(status)) {
            error.userMessage = 'Invalid email or password.';
            return Promise.reject(error);
        }

        // 3) For any OTHER request: on 401/403/419, clear auth and hard-redirect once
        if ([401, 403, 419].includes(status) && !_redirectingToLogin) {
            _redirectingToLogin = true;

            try {
                localStorage.removeItem('token');
                localStorage.removeItem('auth');
            } catch {}

            if (window.location.pathname !== '/login') {
                window.location.replace('/login');
            } else {
                _redirectingToLogin = false;
            }
        }

        return Promise.reject(error);
    }
);

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);
